import { initializeApp } from "firebase/app";
import { getPerformance, trace } from "firebase/performance";

const config = {
  apiKey: process.env.REACT_APP_WHOLESALER_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_WHOLESALER_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_WHOLESALER_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_WHOLESALER_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_WHOLESALER_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_WHOLESALER_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_WHOLESALER_FIREBASE_MEASURMENT_ID,
};

const app = initializeApp(config);
const perf = getPerformance(app);
const FirebaseConfig = { perf, trace, config };

export default FirebaseConfig;
